//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { page } from "@/api/pm/project";
import { dateTimeFormat, dateFormat } from "@/utils/common";
import { getDicData } from "@/api/common/dic";
import { getRoleDeptInfo } from "@/api/base/base";
import { BASIC } from "@/config/constant";
import fetch from "@/axios/promise";

export default {
  name: "invoListPage",
  data() {
    return {
      //
      gobackName: this.$route.params.gobackName,
      open: false,
      // 查询条件
      listQuery: {
        projTypes: [],
        projProps: [],
        respDepts: [],
        statuss: [],
        projCodeName: "",
        respDeptName: "",
        pmName: "",
        status: this.$route.params.status,
        projTypeCode: this.$route.params.projTypeCode,
        respDeptCode: this.$route.params.respDeptCode,
        projStatus: this.$route.params.projStatus,
        pmCode: this.$route.params.pmCode,
        crtDateStart: "",
        crtDateEnd: "",
        currentPage: 1, // 当前页
        pageSize: 5, // 每页数据
        filter: "0" // 是否需要用户过滤 1：需要 0：不需要
      },
      refreshing: false,
      loading: false,
      listData: [],

      filterOpen: false,
      trigger: null,

      projTypeOptions: [],
      projPropOptions: [],
      respDeptOptions: [],

      // 审批状态
      apprStatusOptions: [
        {
          value: "草稿",
          label: "草稿"
        },
        {
          value: "审批中",
          label: "审批中"
        },
        {
          value: "已撤回",
          label: "已撤回"
        },
        {
          value: "被驳回",
          label: "被驳回"
        },
        {
          value: "已通过",
          label: "已通过"
        }
      ],
      // 项目状态
      projStatusOptions: [
        {
          value: "未开始",
          label: "未开始"
        },
        {
          value: "进行中",
          label: "进行中"
        },
        {
          value: "暂停",
          label: "暂停"
        },
        {
          value: "已中止",
          label: "已中止"
        },
        {
          value: "已完成",
          label: "已完成"
        }
      ],

      subitemsExpanded: false
    };
  },
  created() {
    debugger;
    // 加载数据
    this.loadData();
    //加载字典数据
    this.getDicData();
  },
  computed: {},
  mounted: function() {
    //			this.trigger = this.$refs.filterBtn.$el;
  },
  methods: {
    //时间格式化
    dateFormat: function(date) {
      return dateTimeFormat(date);
    },
    // 返回
    goback() {
      if (this.gobackName == "立项总览") {
        if (this.listQuery.projTypeCode == "005") {
          this.$router.push({
            name: "售前人员",
            params: {
              projTypeCode: this.listQuery.projTypeCode,
              respDeptCode: this.listQuery.respDeptCode
            }
          });
        } else {
          this.$router.push({
            name: "立项总览"
          });
        }
      } else {
        // 返回工作台
        this.$router.push({
          name: "workbench"
        });
      }
    },
    // 筛选
    filter() {
      this.filterOpen = !this.filterOpen;
    },
    // 查找
    searchEvent(event) {
      if (event.keyCode == 13) {
        this.listQuery.currentPage = 1;
        this.loadData();
      }
    },
    // 查找
    searchBtn() {
      this.listQuery.currentPage = 1;
      this.filter();
      this.loadData();
    },
    // 清空条件
    clearFilter() {
      this.listQuery.projCodeName = "";
      this.listQuery.respDeptName = "";
      this.listQuery.pmName = "";
      this.listQuery.status = "";
      this.listQuery.projStatus = "";
      // 当前页重置
      this.listQuery.currentPage = 1;

      this.loadData();
    },
    // 数据刷新(下拉)
    refresh() {
      this.refreshing = true;
      this.$refs.container.scrollTop = 0;

      this.listQuery.currentPage = 1;
      setTimeout(() => {
        // refreshing=true 的情况下加载
        this.loadData();
        this.refreshing = false;
      }, 600);
    },
    // 数据加载(上拉)
    load() {
      this.loading = true;
      setTimeout(() => {
        this.listQuery.currentPage++;
        // 加载
        this.loadData2();
        this.loading = false;
      }, 600);
    },
    // 加载
    loadData() {
      var self = this;
      //self.listLoading = true;

      if (self.listQuery.crtDateStart !== "") {
        self.listQuery.crtDateStart = dateFormat(self.listQuery.crtDateStart);
      }
      if (self.listQuery.crtDateEnd !== "") {
        self.listQuery.crtDateEnd = dateFormat(self.listQuery.crtDateEnd);
      }

      var condition = {
        condition: JSON.stringify(this.listQuery)
      };
      page(condition).then(response => {
        // 刷新情况下
        this.listData = response.list;
      });
    },
    // 加载数据
    loadData2() {
      var self = this;
      //self.listLoading = true;

      if (self.listQuery.crtDateStart !== "") {
        self.listQuery.crtDateStart = dateFormat(self.listQuery.crtDateStart);
      }
      if (self.listQuery.crtDateEnd !== "") {
        self.listQuery.crtDateEnd = dateFormat(self.listQuery.crtDateEnd);
      }

      var condition = {
        condition: JSON.stringify(this.listQuery)
      };
      page(condition).then(response => {
        // 加载数据情况下
        var data = response.list;
        for (var i = 0; i < data.length; i++) {
          this.listData.push(data[i]);
        }
      });
    },
    // 进入明细
    itemClick(id) {
      this.$router.push({
        name: "立项详情",
        params: {
          flag: "1",
          mainId: id,
          status: this.listQuery.status,
          projStatus: this.listQuery.projStatus,
          projTypeCode: this.listQuery.projTypeCode,
          respDeptCode: this.listQuery.respDeptCode,
          gobackName: this.gobackName
        }
      });
    },
    // 是否有值
    isExist(value) {
      if (value !== null && value !== undefined && value !== "") {
        return true;
      }
      return false;
    },
    filterProject(type) {
      if (type !== "all") {
        this.listQuery.projTypeCode = type;
      } else {
        this.listQuery.projTypeCode = "";
      }
      this.loadData();
    },
    // 获取字典表中的数据
    getDicData() {
      // 项目类型
      var condition = {
        cateCode: "projType"
      };
      getDicData(condition).then(response => {
        this.projTypeOptions = response;
        this.projTypeOptions.unshift({
          dicCode: "all",
          dicName: "全部"
        });
      });
      // 项目属性
      condition = {
        cateCode: "projProperty"
      };
      getDicData(condition).then(response => {
        this.projPropOptions = response;
      });
      //获取当前用户
      fetch({
        url: BASIC + "/user/currUserInfo",
        method: "GET"
      }).then(res => {
        // 获取承担部门respDeptOptions
        let condition = { groupTypeCode: "depart", companyId: res.companyId };
        getRoleDeptInfo(condition).then(response => {
          this.respDeptOptions = response;
        });
      });
    },
    closeBottomSheet() {
      this.open = false;
    },
    openBotttomSheet() {
      this.open = true;
    },
    // 重置
    resetClick() {
      this.listQuery.projTypes = [];
      this.listQuery.projProps = [];
      this.listQuery.respDepts = [];
      this.listQuery.statuss = [];
      this.listQuery.projCodeName = "";
      this.listQuery.respDeptName = "";
      this.listQuery.pmName = "";
      this.listQuery.status = "";
      this.listQuery.projTypeCode = "";
      this.listQuery.projStatus = "";
      this.listQuery.crtDateStart = "";
      this.listQuery.crtDateEnd = "";
      this.listQuery.currentPage = 1; // 当前页
      this.listQuery.pageSize = 5; // 每页数据
      this.listQuery.filter = "0"; // 是否需要用户过滤 1：需要 0：不需要
      this.loadData();
    }
  }
};



// WEBPACK FOOTER //
// ./src/view/pm/project/projectList.vue